import { render, staticRenderFns } from "./BinUtilityList.vue?vue&type=template&id=b7ff8f60&scoped=true"
import script from "./BinUtilityList.vue?vue&type=script&lang=js"
export * from "./BinUtilityList.vue?vue&type=script&lang=js"
import style0 from "./BinUtilityList.vue?vue&type=style&index=0&id=b7ff8f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ff8f60",
  null
  
)

export default component.exports